import { createContext, useContext, useState, useCallback } from "react";
import AuthDialog from "@/components/AuthDialog";

const AuthDialogCtx = createContext({ open: () => {} });

export const AuthDialogProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, mode: "login" });
  const openDialog = useCallback((mode = "login") => setState({ open: true, mode }), []);
  const closeDialog = useCallback(() => setState((s) => ({ ...s, open: false })), []);

  return (
    <AuthDialogCtx.Provider value={{ open: openDialog, close: closeDialog }}>
      {children}
      <AuthDialog open={state.open} defaultMode={state.mode} onClose={closeDialog} />
    </AuthDialogCtx.Provider>
  );
};

export const useAuthDialog = () => useContext(AuthDialogCtx);
